import React from 'react';
import ReportViewer from "./base/ReportViewer";

const ListeChasseurs = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"ListeChasseurs"}/>
        </div>
    );
}
export default ListeChasseurs;